import React from 'react'
import TechnologyItem from './TechnologyItem'

function Technologies() {

    return (
        <ul className='mt-2 flex justify-evenly flex-wrap md:w-1/2 mx-5'>
            <TechnologyItem name="React.js" />
            <TechnologyItem name="Node.js" />
            <TechnologyItem name="Laravel" />
            <TechnologyItem name="Tailwind CSS" />
        </ul>
    )
}

export default Technologies